export const MOBILE_HEADER_HEIGHT = 64;
